import { connect } from 'react-redux';
import Component from './StreamRoot';
import { setHeaderTitle } from '../../../../actions/layout';
import { listStateFromCRUD } from '../../../../selectors/crud';
import {
  STREAM_ROUTER_NEW,
  STREAM_ROUTER_LIVE,
} from '../constants';
import {
  STREAM_ROUTER_VOD,
  VOD_ROUTER_NEW,
} from './../../CustomStream/constants';

import { push } from 'react-router-redux/lib/actions';

export default connect(
  ({ customStream }) => ({
    ...listStateFromCRUD(customStream)
  }),
  dispatch => {
    return {
      updateHeaderTitle: title => dispatch(setHeaderTitle(title)),
      goToLive: () => dispatch(push(STREAM_ROUTER_LIVE)),
      // goToUpcomming: () => dispatch(push(STREAM_ROUTER_UPCOMMING)),
      // goToPast: () => dispatch(push(STREAM_ROUTER_PAST)),
      gotoVoD: () => dispatch(push(STREAM_ROUTER_VOD)),
      addStream: () => dispatch(push(STREAM_ROUTER_NEW)),
      addVoD: (category_id) => dispatch(push(category_id ? VOD_ROUTER_NEW + '?category_id=' + category_id : VOD_ROUTER_NEW))
    };
  },
)(Component);



// WEBPACK FOOTER //
// ./src/components/Stream/LiveStream/StreamRoot/index.js